/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SchedulerCrewResponse } from '../../models/scheduler-crew-response';
import { UpdateSchedulerCrewRequest } from '../../models/update-scheduler-crew-request';

export interface UpdateSchedulerCrew$Params {
  id: number;
      body: UpdateSchedulerCrewRequest
}

export function updateSchedulerCrew(http: HttpClient, rootUrl: string, params: UpdateSchedulerCrew$Params, context?: HttpContext): Observable<StrictHttpResponse<SchedulerCrewResponse>> {
  const rb = new RequestBuilder(rootUrl, updateSchedulerCrew.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SchedulerCrewResponse>;
    })
  );
}

updateSchedulerCrew.PATH = '/api/scheduler/crew/{id}';
